import React from "react";

import Slider from "../common-components/Slider";
import Categories from "../common-components/Categories";

export default function Module_2({ data }) {
    ``
    return (
        <div className="container mt-5">
            <Categories categories={data} />
            {/* <Slider /> */}
        </div>
    );
}
